export enum TabType {
  Overview = "Overview",
  Appointments = "Appointments",
  Notes = "Notes",
  Note = "Note",
  Intake = "Intake",
  Hx = "Hx",
  Meds = "Meds",
  Orders = "Orders",
  Profile = "Profile",
  Tasks = "Tasks",
  Task = "Task",
  Messages = "Messages",
  Message = "Message",
  AI = "AI",
  Supplements = "Supplements",
  Records = "Records",
  Hint = "Hint",
  Trends = "Trends",
  Fax = "Fax",
  FaxCompose = "FaxCompose",
  /**
   * The AVS-review tab, which stacks the Summary, Health Goals, and Protocol Updates sections in
   * one pane with one shared "Send to Patient" action. See `AvsReviewTab.tsx`.
   */
  AvsReview = "AvsReview",
}

// Tabs that hold transient state: never persisted to local storage, and listed outside the tab
// selector dropdown. Lives here (not in TabbedPane) so lib/layout does not import from components/.
export const MEMORY_ONLY_TAB_TYPES: string[] = [
  TabType.Task,
  TabType.Note,
  TabType.Message,
  TabType.FaxCompose,
  TabType.AvsReview,
];

/** Patient EHR URL query keys (e.g. Task Manager → patient deep link). */
export const PatientEhrQuery = {
  tab: "tab",
  scribeId: "scribeId",
  taskId: "taskId",
  noteId: "noteId",
  formId: "formId",
  labId: "labId",
  documentId: "documentId",
} as const;

export interface View {
  version?: number;
  name: string;
  editable: boolean;
  deletable: boolean;
  panes: PaneConfig[];
}

export interface PaneConfig {
  paneId: string;
  deletable?: boolean;
  openTabs: TabInformation[];
  style?: React.CSSProperties;
}

export interface TabInformation {
  id: string; // This is the string that used to be stored in PaneConfig.openTabs.
  type: string; // This will decide what kind of tab it is. (Note, Med, Order, etc.)
  active: boolean; // Whether the tab is currently open.
  /**
   * ☢️ Do not add any additional properties to TabInformation to hold sensitive data.
   * If you do need to store sensitive data like resource IDs, use the existing data property.
   * ADDING ADDITIONAL PROPERTIES WILL LEAD TO PATIENT DATA LEAKS.
   */
  data?: Record<string, unknown>; // This is the data object that may contain the noteId.
}
